import Image from 'react-bootstrap/Image'
import QuantureLogo from './../assets/Quanture_Logo.png';

//Questo comeponente rappresenta il footer dell'applicazione
export const Footer:React.FC = () =>{
    return(
        <div className="container-fluid text-bg-dark" >
            <div className="row text-center">
                <div className="col">
                    <Image src={QuantureLogo}  width={150}  ></Image>
                </div>
            </div>
        </div>
    );
}